import { useEffect, useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { post_files_act, post_files_saga_act } from "../../../store/actions/master";

const masterGalleryHooks = (props) => {
    const dispatch = useDispatch();
    const post_files = useSelector(state => state.post_files);
    const get_post_files = (page) => {

        dispatch(
            post_files_saga_act({ token: props.token, user_id: props.id, page, })
        );
    };
    useEffect(async () => {
        dispatch(
            post_files_act({
                loading: true
            })
        );
    }, [props.activePage]);
    useEffect(async () => {
        get_post_files(1);
    }, []);
    return { post_files, get_post_files };
};
export default masterGalleryHooks;